import {createContext} from "react";

import type {JsonPath} from "./types.ts";

type CoeditingUI = Readonly<{
    container: HTMLElement | null;
    setContainer: (container: HTMLElement | null) => void;
    selectedPath: JsonPath | undefined;
    hoveredPath: JsonPath | undefined;
    viewOnly: boolean;
}>;

export const CoeditingUIContext = createContext<CoeditingUI>({
    container: null,
    setContainer: () => {},
    selectedPath: undefined,
    hoveredPath: undefined,
    viewOnly: false,
});
